import setErrors from "./setErrors";
import setHistory from "./setHistory";

const reducerFunctions = {
  setErrors,
  setHistory,
};

export default reducerFunctions;
